var React = require('react');

function Zurich (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none"},[React.createElement("path",{"fill":"#FFF","d":"M.885 1.016H468.61v468.943H.885z","key":0}),React.createElement("path",{"fill":"#268BCC","d":"M468.64 470H.863V.935z","key":1})]));
}

Zurich.defaultProps = {"viewBox":"0 0 469 470"};

module.exports = Zurich;

Zurich.default = Zurich;
